import React from "react";

const ThermalPrintHeader = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft: "50px" }}>
        MAR & SONS FISH COMPANY
      </p>
      <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft: "50px" }}>
        ShopNo:7 Sandhaipettai Fish Market
      </p>
      <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft: "50px" }}>
        Thennampalayam, Tirupur 641 604.
      </p>
      <p style={{ fontSize: "14px", fontWeight: 900, paddingLeft: "50px" }}>
        9952420505, 9500951327, 9894777666
      </p>
    </div>
  );
};

export default ThermalPrintHeader;
